export const MEMBERS_NATIVE_APP_ID = 'com.privana.members'
export const MEMBERS_MOBILE_CALLBACK_URI = 'com.privana.members://dev-fcv2y3k6q4jfmx5k.us.auth0.com/capacitor/com.privana.members/callback'

export function deriveMembersMobileAuth0Callback(auth0Domain, appId = MEMBERS_NATIVE_APP_ID) {
  const normalizedDomain = String(auth0Domain || '').trim()
  const normalizedAppId = String(appId || '').trim()
  if (!normalizedDomain || !normalizedAppId) return ''
  return `${normalizedAppId}://${normalizedDomain}/capacitor/${normalizedAppId}/callback`
}

export function resolveMembersMobileRedirectUri({ explicitRedirectUri, auth0Domain, appId = MEMBERS_NATIVE_APP_ID } = {}) {
  const explicit = String(explicitRedirectUri || '').trim()
  if (explicit) return explicit
  return deriveMembersMobileAuth0Callback(auth0Domain, appId)
}
